// extracted by mini-css-extract-plugin
export default {"welcomeMessage":"quizHome_welcomeMessage__40PGa"};